import { Button } from '@circlefin/components'
import { accountActivitySection } from '@services/sections/lib/accountActivity'
import { ProposalType, UserStatusType, type User } from '@shared/graphql'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

export interface UsersTableApprovalLink {
  /**
   * Users.
   */
  user: User
}

/**
 * Maps user status to corresponding proposal type for approval requests.
 */
const getProposalType = (status: UserStatusType) => {
  if (status === UserStatusType.PENDING_INVITE_APPROVAL) {
    return ProposalType.USER_INVITE
  }

  if (status === UserStatusType.PENDING_REMOVE_APPROVAL) {
    return ProposalType.USER_REMOVE
  }
}

export const UsersTableApprovalLink: React.FC<UsersTableApprovalLink> = ({
  user,
}) => {
  const { t } = useTranslation('settings')

  if (
    ![
      UserStatusType.PENDING_INVITE_APPROVAL,
      UserStatusType.PENDING_REMOVE_APPROVAL,
    ].includes(user.status)
  ) {
    return null
  }

  return (
    <Button.Link
      anchorComponent={Link}
      className="-ml-1"
      href={{
        pathname: accountActivitySection.route,
        query: {
          proposalType: getProposalType(user.status),
          proposalId: user.proposalId,
        },
      }}
      size="sm"
      variant="text"
    >
      {t('personalInfo.viewApprovalRequest')}
    </Button.Link>
  )
}
